export enum FileTypeEnum {
  XLSX = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  CSV = "text/csv",
  TEXT = "text/plain",
}
